import '../navbar-csrf.js';
import { applyOtpCodeInputAttrs, refreshOtpCodeInputs } from '../shared/otp-code-input.js';
import { startOtpResendCooldown } from '../shared/otp-resend-cooldown.js';

function otpSentFallback(identifier) {
  var s = String(identifier || '').trim();
  var at = s.indexOf('@');
  var isEmail = at > 0 && at < s.length - 1 && !/\s/.test(s);
  if (s && !isEmail) {
    return 'If an account is registered under this username, we sent a code to its primary email address.';
  }
  return 'If an account is registered under this primary email, we sent it a code.';
}

function setBusy(btn, busy, idle, busyLabel) {
  if (!btn) return;
  btn.disabled = busy;
  if (busy) {
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('opacity-70');
    btn.textContent = busyLabel;
    return;
  }
  btn.removeAttribute('aria-disabled');
  btn.classList.remove('opacity-70');
  btn.textContent = idle;
}

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-public-otp]');
  if (!root) return;
  var sendForm = root.querySelector('[data-otp-send]');
  var verifyForm = root.querySelector('[data-otp-verify]');
  var statusEl = root.querySelector('[data-otp-status]');
  var sendBtn = root.querySelector('[data-otp-send-btn]');
  var countdownEl = root.querySelector('[data-otp-resend-countdown]');
  var verifyBtn = root.querySelector('[data-otp-verify-btn]');
  var emailInput = sendForm && sendForm.querySelector('[data-otp-ident]');
  var tokenInput = verifyForm && verifyForm.querySelector('[data-otp-token]');
  applyOtpCodeInputAttrs(tokenInput);
  var codeSent = !!(verifyForm && !verifyForm.classList.contains('hidden'));

  function sendBtnLabel() {
    return codeSent ? 'Resend code' : 'Send code';
  }

  function showStatus(text, isError) {
    if (!statusEl) return;
    statusEl.textContent = text;
    statusEl.classList.toggle('text-red-600', !!isError);
    statusEl.classList.toggle('text-gray-600', !isError);
    statusEl.classList.remove('hidden');
  }

  if (sendForm) {
    sendForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput ? emailInput.value.trim() : '';
      var fallback = otpSentFallback(email);
      var cooldownSeconds = null;
      setBusy(sendBtn, true, sendBtnLabel(), 'Sending…');
      fetch('/auth/otp/send', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ email: email, purpose: 'attendance_portal' }),
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (data.ok === false && data.error) {
            showStatus(data.error, true);
            return;
          }
          showStatus(data.message || fallback, false);
          codeSent = true;
          cooldownSeconds = data.retry_after == null ? 30 : data.retry_after;
          if (verifyForm) {
            verifyForm.classList.remove('hidden');
            refreshOtpCodeInputs(root);
          }
        });
      }).catch(function () {
        showStatus('Could not send a code. Try again.', true);
      }).finally(function () {
        setBusy(sendBtn, false, sendBtnLabel(), 'Sending…');
        if (cooldownSeconds !== null) {
          startOtpResendCooldown({
            button: sendBtn,
            countdownEl: countdownEl,
            seconds: cooldownSeconds,
          });
        }
      });
    });
  }

  if (verifyForm) {
    verifyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput ? emailInput.value.trim() : '';
      var token = tokenInput ? tokenInput.value.replace(/\D/g, '') : '';
      setBusy(verifyBtn, true, 'Sign in', 'Signing in…');
      fetch('/auth/otp/verify', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ email: email, token: token, purpose: 'attendance_portal' }),
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || !data.ok) {
            showStatus(data.error || 'Could not verify that code.', true);
            return;
          }
          window.location.assign(data.redirect || '/');
        });
      }).catch(function () {
        showStatus('Could not verify that code.', true);
      }).finally(function () {
        setBusy(verifyBtn, false, 'Sign in', 'Signing in…');
      });
    });
  }
});
